import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import styles from './index.module.css';
import { NavLink, useLocation } from 'react-router-dom';
import { Tooltip } from 'antd';
import { RiHome6Line } from 'react-icons/ri';
import { FiUsers } from 'react-icons/fi';
import { TiArrowSortedDown } from 'react-icons/ti';
import { RiPresentationLine } from 'react-icons/ri';
import { GrCatalogOption, GrUserExpert } from 'react-icons/gr';
import { AiOutlineUsergroupAdd } from 'react-icons/ai';
import { RiBloggerLine } from 'react-icons/ri';
import { BiLogoDiscourse } from 'react-icons/bi';
import { LuUser } from 'react-icons/lu';
import { TbQuestionMark } from 'react-icons/tb';
import { useEffect } from 'react';
import { FaRegNewspaper } from "react-icons/fa";
import { GrTransaction } from "react-icons/gr";
import { SiPowerpages } from "react-icons/si";
import { CgMenuGridO } from "react-icons/cg";
import { FaQuestion } from "react-icons/fa6";
import { TbCertificate2 } from "react-icons/tb";
import { IoGitPullRequestSharp } from "react-icons/io5";
import { CiSettings } from "react-icons/ci";

// import MdOutlineAssessment from

import {
  MdCurrencyExchange,
  MdOutlineAssessment,
  MdOutlineContentPaste,
  MdOutlineEmojiEvents,
  MdOutlineSubscriptions,
} from 'react-icons/md';
import { PiCertificateLight } from 'react-icons/pi';

const Html = ({ tabclass, urlAllow, route, isOpen, user }) => {
  const location = useLocation();

  const menus = [
    {
      name: 'Main Menu',
    },
    {
      name: 'Dashboard',
      icon: <RiHome6Line className="text-[#fff] shrink-0 text-lg" />,
      url: '/dashboard',
      key: 'readDashboard',
    },
    {
      name: 'Sub Admin',
      icon: <FiUsers className="text-[#fff] shrink-0 text-lg" />,
      key: 'subadmin_get',
      url: '/sub-admin',
      tab: 'sub-admin',
    },
    {
      name: 'User Management',
      icon: <LuUser className="text-[#fff] shrink-0 text-lg" />,
      key: 'user_get',
      tab: 'user',
      menu: [
        // {
        //   name: 'Roles',
        //   url: '/roles',
        //   key: 'readRoles',
        // },
        {
          name: 'Users',
          url: '/users',
          key: 'user_get',
        },
      ],
    },
    // {
    //   name: 'Catalogue',
    //   icon: <GrCatalogOption className="text-[#fff] shrink-0 text-lg" />,
    //   key: 'category_get',
    //   tab: 'catalogue',
    //   menu: [

    //     {
    //       name: 'Categories',
    //       url: '/categories',
    //       key: 'category_get',
    //     },
    //   ],
    // },
    {
      name: 'Categories',
      icon: <GrCatalogOption className="text-[#fff] shrink-0 text-lg" />,
      key: 'category_get',
      url: '/categories',
    },
    {
      name: 'Content Management',
      icon: <GrCatalogOption className="text-[#fff] shrink-0 text-lg" />,
      key: 'content_get',
      url: '/content',
    },
    {
      name: 'Recommended Products',
      icon: <RiBloggerLine className="text-[#fff] shrink-0 text-lg" />,
      url: '/products',
      key: 'blog_get',
    },
    {
      name: "FAQ's",
      icon: <FaQuestion className="text-[#fff] shrink-0 text-lg" />,
      url: '/faq',
      key: 'faqs_get',
    },
    {
      name: 'Courses',
      icon: <BiLogoDiscourse className="text-[#fff] shrink-0 text-lg" />,
      url: '/courses',
      key: 'course_get',
    },
    {
      name: 'Subscription Plan',
      icon: <MdOutlineSubscriptions className="text-[#fff] shrink-0 text-lg" />,
      key: 'pan_get',
      tab: 'plan',
      menu: [
        {
          name: 'Features',
          url: '/features',
          key: 'readPlan',
        },
        {
          name: 'Plans',
          url: '/plans',
          key: 'readPlan',
        },
      ],
    },

    {
      name: 'Dynamic Pages',
      icon: <SiPowerpages  className="text-[#fff] shrink-0 text-lg" />,
      key: 'page_get',
      tab: 'plan',
      menu: [
        {
          name: 'Lessons From Parents',
          url: '/lessons/parents',
          key: 'readLessons',
        },
        {
          name: 'Insights From Coaches',
          url: '/insights/coaches',
          key: 'readCoaches',
        },
      ],
    },
    {
      name: 'Menu item',
      icon: <CgMenuGridO  className="text-[#fff] shrink-0 text-lg" />,
      url: '/menu',
      key: 'menu_get',
    },
    // {
    //   name: 'Currency',
    //   icon:<MdCurrencyExchange className="text-[#fff] shrink-0 text-lg" />      ,
    //   url: '/currency',
    //   key: 'readCurrency',
    // },
    // {
    //   name: 'Frontend Users',
    //   icon: <RiPresentationLine className="text-[#fff] shrink-0 text-lg" />,
    //   key: 'readCustomers',
    //   tab: 'customer',import { FaRegNewspaper } from "react-icons/fa";
    //   menu: [
    //     {
    //       name: 'Frontend User Roles',
    //       url: '/skill-roles',
    //       key: 'readCustomers'
    //     },
    //     {
    //       name: 'Frontend Users',
    //       url: '/customer',
    //       key: 'readCustomers'
    //     },
    //   ]
    // },
    // {
    //   name: 'Participant Type',
    //   icon: <RiHome6Line className="text-[#fff] shrink-0 text-lg" />,
    //   url: '/participant-type',
    //   key: 'readParticipantTypes',
    // },
    {
      name: 'Question Bank',
      icon: <TbQuestionMark className="text-[#fff] shrink-0 text-lg" />,
      url: '/questions',
      key: 'question_get',
    },
    // {
    //   name: 'Group',
    //   icon: <AiOutlineUsergroupAdd className="text-[#fff] shrink-0 text-lg" /> ,
    //   url: '/group',
    //   key: 'readGroup',
    // },
    {
      name: 'Certificate ',
      icon: <PiCertificateLight className="text-[#fff] shrink-0 text-lg" />,
      url: '/certificate ',
      key: 'readCertification',
    },
    {
      name: 'Certificate Template',
      icon: <TbCertificate2 className="text-[#fff] shrink-0 text-lg" />,
      url: '/certificate-templates ',
      key: 'template_get',
    },
    {
      name: 'Certificate Requests ',
      icon: <IoGitPullRequestSharp className="text-[#fff] shrink-0 text-lg" />,
      url: '/certificate-requests',
      key: 'template_get',
    },
    {
      name: 'Assessment ',
      icon: <MdOutlineAssessment className="text-[#fff] shrink-0 text-lg" />,
      url: '/assessment  ',
      key: 'assessment_get',
    },

    {
      name: 'News Letters ',
      icon: <FaRegNewspaper className="text-[#fff] shrink-0 text-lg" />,
      url: '/Newsletters  ',
      key: 'News__Letters',
    },

    {
      name: 'Transactions',
      icon: <GrTransaction className="text-[#fff] shrink-0 text-lg" />,
      url: '/Transactions  ',
      key: 'News__Letters',
    },
    {
      name: 'Setting',
      icon: <CiSettings  className="text-[#fff] shrink-0 text-lg" />,
      url: '/setting  ',
      key: 'setting',
    },
    
  ];

  return (
    <>
      <div
        className={`px-[8px] ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="scrollbar_sidebar space-y-2 px-2">
          {menus.map((itm) => {
            return (
              <>
                {itm.icon ? (
                  <>
                    <li className="sidebar_flex">
                      {itm.menu ? (
                        <>
                          {urlAllow(itm.key) ? (
                            <>
                              <Disclosure
                                as="div"
                                defaultOpen={tabclass(itm.tab)}
                              >
                                {({ open }) => (
                                  <>
                                    <Tooltip placement="right" title={itm.name}>
                                      <Disclosure.Button className="w-full p-2.5 rounded-md flex items-center justify-between text-[#4A545E]  hover:!text-[#5577FF] gap-[12px] hover:bg-[#95959526]/10 transition-all duration-300">
                                        <span className="text-sm font-normal text-inherit flex items-center gap-[12px] crm">
                                          {itm.icon}
                                          <span className=" text-white leading-none sidebar_text">
                                            {' '}
                                            {itm.name}
                                          </span>
                                        </span>

                                        <TiArrowSortedDown
                                          className={`${open ? '' : '-rotate-90 transform'
                                            } h-4 w-4 transition-all duration-500  text-[#7E8B99]`}
                                        />
                                      </Disclosure.Button>
                                    </Tooltip>
                                    <Transition
                                      enter="transition duration-300 ease-in-out"
                                      enterFrom="transform scale-95 opacity-0"
                                      enterTo="transform scale-300 opacity-300"
                                      leave="transition duration-300 ease-in-out"
                                      leaveFrom="transform scale-300 opacity-300"
                                      leaveTo="transform scale-95 opacity-0"
                                    >
                                      <Tooltip
                                        placement="right"
                                        title={itm.name}
                                      >
                                        <Disclosure.Panel className="pl-[30px] mt-[4px] ">
                                          <ul className="space-y-2 space-y-2 border-l-[1px] border-solid border-[#ffffff5c] pl-2">
                                            {itm.menu.map((sitm) => {
                                              return (
                                                <>
                                                  {urlAllow(sitm.key) ? (
                                                    <li>
                                                      {' '}
                                                      <NavLink
                                                        className={(isActive) =>
                                                          'p-2.5 rounded-md block text-sm font-normal text-[#fff] cursor-pointer hover:!text-[#fff ] hover:bg-[#95959526]/10 !no-underline transition-all ' +
                                                          (location?.pathname ==
                                                            sitm.url &&
                                                            ' !text-[#fff] !bg-[#A12238] !font-medium')
                                                        }
                                                        to={sitm.url}
                                                      >
                                                        <span
                                                          className="text-inherit leading-none sidebar_text"
                                                          title={sitm.name}
                                                        >
                                                          {' '}
                                                          {sitm.name}
                                                        </span>
                                                      </NavLink>
                                                    </li>
                                                  ) : null}
                                                </>
                                              );
                                            })}
                                          </ul>
                                        </Disclosure.Panel>
                                      </Tooltip>
                                    </Transition>
                                  </>
                                )}
                              </Disclosure>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {urlAllow(itm.key) ? (
                            <>
                              <Tooltip placement="right" title={itm.name}>
                                <NavLink
                                  to={itm.url}
                                  className={(isActive) =>
                                    'w-full p-2.5 rounded-md flex items-center gap-[6px] text-sm font-normal text-[#fff] hover:!text-[#fff] hover:bg-[#95959526]/10 !no-underline transition-all whitespace-nowrap ' +
                                    (location?.pathname == itm.url &&
                                      ' !text-[#fff] !bg-[#A12238] !font-medium')
                                  }
                                >
                                  {itm.icon}
                                  <span className="!text-white leading-none sidebar_text">
                                    {itm.name}
                                  </span>
                                </NavLink>
                              </Tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <></>
                )}
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
